import { useQuery } from '@tanstack/react-query';
import {
  GetReferralProgramEntity,
  ReferralProgramService,
} from 'services/openapi';
import { ReferrallQueryKeys } from './constants';

export const useGetReferralDetailQuery = () => {
  const queryKey = [ReferrallQueryKeys.GET_REFERRAL_DETAIL];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetReferralProgramEntity, Error>({
    queryKey,
    queryFn: () =>
      ReferralProgramService.referralProgramControllerGetReferralProgram(),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey,
    refetch,
  };
};
